module.exports = __webpack_public_path__ + "img/ok_white.1cc7346e.svg";